// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSingleColumn_root__2so78","layoutWrapperMain":"LayoutSingleColumn_layoutWrapperMain__3JF6g"};